import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import Flag from '../../../common/components/Flag';
import { ITableHeader } from '../../../common/components/TableList/typings';
import ClubAvatar from '../../clubs/Avatar';
import CompetitionAvatar from '../../competitions/Avatar';
import { getCompetitionHref } from '../../competitions/utils';
import { getTeamHref } from '../../teams/utils';
import { getTournamentHref } from '../../tournaments/utils';
import { ITournamentAward } from '../typings';

const styles = {
  rowContent: {
    display: 'flex',
    alignItems: 'center',
  },
  competitionIcon: {
    marginRight: 8,
  },
  flag: {
    marginLeft: 8,
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

interface IProps {
  tableData: ITournamentAward;
  headers: ITableHeader[];
  classes: any;
  update?: (award: ITournamentAward) => void;
}

class TournamentAwardRow extends React.Component<IProps> {
  public render() {
    const { tableData: award, headers, classes, update } = this.props;

    return (
      <TableRow
        hover
        onClick={update ? () => update(award) : undefined}
        style={update ? { cursor: 'pointer' } : undefined}
      >
        {headers.map(header => (
          <TableCell key={header.id}>
            {this.renderCell(header.id, award, classes)}
          </TableCell>
        ))}
      </TableRow>
    );
  }

  private renderCell(columnId: string, award: ITournamentAward, classes: any) {
    const { competition, tournament, winnerTeam, runnerUpTeam } = award;

    switch (columnId) {
      case 'competition.name':
        return competition ? (
          <div className={classes.rowContent}>
            <div className={classes.competitionIcon}>
              <CompetitionAvatar data={competition} />
            </div>
            <a
              href={getCompetitionHref(competition.area?.slug, competition.slug)}
              className={classes.link}
            >
              {competition.name}
            </a>
          </div>
        ) : '-';

      case 'tournamentName':
        return tournament ? (
          <a
            href={getTournamentHref(tournament)}
            className={classes.link}
          >
            {award.tournamentName}
          </a>
        ) : (
          award.tournamentName
        );

      case 'winnerTeam.name':
        return winnerTeam ? (
          <div className={classes.rowContent}>
            <div className={classes.competitionIcon}>
              <ClubAvatar club={winnerTeam.club} />
            </div>
            <a
              href={getTeamHref(winnerTeam)}
              className={classes.link}
            >
              {winnerTeam.name}
            </a>
            {winnerTeam.club?.isSelection && winnerTeam.club.country && (
              <Flag
                country={winnerTeam.club.country}
                style={styles.flag}
              />
            )}
          </div>
        ) : '-';

      case 'runnerUpTeam.name':
        return runnerUpTeam ? (
          <div className={classes.rowContent}>
            <div className={classes.competitionIcon}>
              <ClubAvatar club={runnerUpTeam.club} />
            </div>
            <a
              href={getTeamHref(runnerUpTeam)}
              className={classes.link}
            >
              {runnerUpTeam.name}
            </a>
            {runnerUpTeam.club?.isSelection && runnerUpTeam.club.country && (
              <Flag
                country={runnerUpTeam.club.country}
                style={styles.flag}
              />
            )}
          </div>
        ) : '-';

      default:
        return '';
    }
  }
}

export default withStyles(styles)(TournamentAwardRow);
